import { ApplicationInsights } from '@microsoft/applicationinsights-web';

const appInsights = new ApplicationInsights({
  config: {
    instrumentationKey: process.env.REACT_APP_INSTRUMENTATION_KEY, // Use the key from Step 1
    enableAutoRouteTracking: true, // Automatically track page views
  },
});

appInsights.loadAppInsights();

export { appInsights };
